const loadedCoachAvatarUrls = new Set();
const listenersByUrl = new Map();

export function isCoachAvatarImageLoaded(url) {
  return Boolean(url) && loadedCoachAvatarUrls.has(String(url));
}

export function markCoachAvatarImageLoaded(url) {
  if (!url) return;
  const key = String(url);
  if (loadedCoachAvatarUrls.has(key)) return;
  loadedCoachAvatarUrls.add(key);
  for (const listener of listenersByUrl.get(key) || []) listener();
}

export function subscribeCoachAvatarImageLoaded(url, listener) {
  if (!url || typeof listener !== 'function') return () => {};
  const key = String(url);
  let listeners = listenersByUrl.get(key);
  if (!listeners) {
    listeners = new Set();
    listenersByUrl.set(key, listeners);
  }
  listeners.add(listener);
  if (loadedCoachAvatarUrls.has(key)) listener();
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) listenersByUrl.delete(key);
  };
}

export function resetCoachAvatarImageResourceForTests() {
  loadedCoachAvatarUrls.clear();
  listenersByUrl.clear();
}
